import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '@ids-components';
import { ThreatService } from '@ids-services';
import { ThreatGroupListComponent } from './threat-group-list/threat-group-list.component';
import { ThreatListComponent } from './threat-list/threat-list.component';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
  imports: [FormsModule, ToggleSwitchModule, ThreatGroupListComponent, ThreatListComponent],
})
export class OverviewComponent extends BaseComponent implements OnInit {
  isGrouping: boolean | null = null;

  constructor(
    private route: ActivatedRoute,
    private threatSrv: ThreatService,
  ) {
    super();
  }

  async ngOnInit() {
    await this.prepareConfigs();
    const isGrouping = JSON.parse(localStorage.getItem('isThreatGroup') || 'true');
    this.isGrouping = isGrouping;
    // Route change
    this.route.queryParams.subscribe((params) => {
      if (!!Object.keys(params)?.length) {
        localStorage.setItem('isThreatGroup', 'false');
        this.isGrouping = false;
      }
    });
  }

  onSwitchGrouping(isGrouping: boolean) {
    localStorage.setItem('isThreatGroup', isGrouping.toString());
    this.threatSrv.setThreatsCounter(this.breadcrumbConfig?.organizationId, this.breadcrumbConfig?.projectId);
  }
}
